window.addEventListener('load', function() {
  var checkLoop = setInterval(function() {
    var buttonContainer = document.querySelector('.okeReviews-reviewsCarousel-header-reviewsCount');
    var showAllReviewsLink = document.createElement('a');
    if (buttonContainer) {
      showAllReviewsLink.setAttribute('class', 'okeReviews-button okeReviews-allReviewsButton');
      showAllReviewsLink.setAttribute('href', '/pages/reviews');
      showAllReviewsLink.innerHTML = 'see all reviews';
      buttonContainer.appendChild(showAllReviewsLink);
      clearInterval(checkLoop);
    }
  }, 100);
})